module.exports = __webpack_public_path__ + "static/news-image-min-503d7746b3a2252c70d7e8963843d7bf.jpg";